import { Injectable } from '@angular/core';
import {environment as env} from "../../environments/environment";
import {Router} from "@angular/router";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import { StorageService } from '../shared/services/storage.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private isAuthenticated: boolean = false;
  private HTTPheaders;
  private options;

  constructor(
      private router: Router,
      private http: HttpClient,
      private storageService: StorageService
  ) {
    this.HTTPheaders = ({
      'Content-Type': 'application/json',
    });
    this.options = ({
      headers: this.HTTPheaders,
    })
  }

  login(email: string, password: string): Observable<object> {
    const body = { email, password };
    return this.http.post(env.baseUrl + "login", body, this.options);
  }

  logout(): void {
    this.isAuthenticated = false;
    localStorage.clear();
    sessionStorage.clear();
    this.router.navigate(["/auth/login"]);
  }

  getUserProfile(): Observable<any> {
    return this.http.get<any>(env.baseUrl + `profile`);
  }

  updateProfile(request: any): Observable<any> {
    return this.http.post<any>(env.baseUrl + `profile`, request);
  }

  changePassword(request: any): Observable<object> {
    return this.http.put(
      env.baseUrl + "update-password",
      request,
      this.options
    );
  }

  resetPassword(request: any): Observable<object> {
    return this.http.post(
      env.baseUrl + "forgot-password",
      request,
      this.options
    );
  }

  logOutApi(): Observable<object> {
    return this.http.post(
        env.baseUrl + "logout",
        this.options
    );
  }

  // Non richiesto dall'utente, endpoint non esistente 
  /* refreshToken(token: string): Observable<object> {
    return this.http.get(
      env.baseUrl + `Auth/RefreshToken?JwtToken=${token}`,
      this.options
    );
  } */

  getUser() {
    return this.storageService.getFromLocalOrSessionStorage('user')!;
  }

  getRole() {
    const user = this.getUser();
    return user ? user.role : 'User undefined' // Restituisce il ruolo dell'utente
  }

}
